import { Component, input } from '@angular/core';
import { DetailedQuote } from '../../../../domain/quote.domain';
import { NumberPipe } from '../../../../pipes/number.pipe';
import { PercentPipe } from '../../../../pipes/percent.pipe';
import { CurrencyPipe } from '../../../../pipes/currency.pipe';
import { QuoteIssueType } from '../domain';

@Component({
  selector: 'td-wb-todays-change',
  templateUrl: 'todays-change.component.html',
  styleUrls: ['todays-change.component.scss'],
  imports: [
    NumberPipe,
    CurrencyPipe,
    PercentPipe
  ]
})
export class TodaysChangeComponent {
  readonly quote = input<DetailedQuote>(undefined);

  /**
   * Return true if dollar change is not 0
   *
   * @returns
   */
  hasDollarChanged(): boolean {
    const quote = this.quote();
    return quote.dollarChange !== undefined
      && quote.dollarChange !== 0;
  }

  /**
   * Return true if dollar change is greater than 0
   *
   * @returns
   */
  hasDollarChangedUp(): boolean {
    return this.quote().dollarChange > 0;
  }

  /**
   * Return true if dollar change is less than 0
   *
   * @returns
   */
  hasDollarChangedDown(): boolean {
    return this.quote().dollarChange < 0;
  }

  /**
   * Return true if issue type is 'INDEX'
   *
   * @returns
   */
  isIssueTypeIndex(): boolean {
    return this.quote().issueType === QuoteIssueType.INDEX;
  }

  /**
   * Return true if last price is 1 or more
   *
   * @returns
   */
  isLastPriceOneOrMore(): boolean {
    return this.quote().lastPrice >= 1.00;
  }
}
